import { createFileRoute } from '@tanstack/react-router';

import { requireTwoFactorEnrolment } from '@/app/guards';
import { AdminShell } from '@/app/shell';
import { LandingPage } from '@/features/auth';
import { organizationSummaryQueryOptions } from '@/features/organizations';
import { OverviewPage } from '@/features/overview';
import { session } from '@/shared/session/session';

/**
 * One URL, two faces: the portal for visitors, the console home once signed in. The component
 * reads the live session (not route context) so a sign-in on this page switches without a
 * navigation.
 */
function Index() {
  const { me } = session.useSession();
  if (!me) return <LandingPage />;
  return (
    <AdminShell>
      <OverviewPage />
    </AdminShell>
  );
}

export const Route = createFileRoute('/')({
  staticData: { crumbKey: 'nav.overview', tours: ['platform.welcome', 'platform.overview'] },
  beforeLoad: async ({ context, location }) => {
    const me = await context.session.ensureSession(context.queryClient);
    if (me) requireTwoFactorEnrolment(me, location);
    return { me };
  },
  loader: ({ context }) =>
    context.me
      ? context.queryClient.query({ ...organizationSummaryQueryOptions(), staleTime: 'static' })
      : undefined,
  component: Index,
});
